<template>
  <ResponsiveMediaGallery
    v-if="images.length"
    :items="images"
    :aspect-ratio="1.35"
    :grid-min-width="230"
    aria-label="Event gallery"
  />
</template>
<script>
import ResponsiveMediaGallery from '../media/ResponsiveMediaGallery.vue';

export default {
  name: 'CultureGallery',
  components: { ResponsiveMediaGallery },
  props: { images: { type: Array, default: () => [] } },
};
</script>
